<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="nirCompensationAgreement"
        :is-no-changes="isNoChanges"
        @save="saveNirCompensationAgreement"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="this.workTypeRusName(workTypeName.NirCompensationAgreement)" />

          <AuthorsCard
            class="mt-4"
            title="Ответственный исполнитель"
            :selected-item.sync="nirCompensationAgreement.commonWork.authors"
            :is-show-mode="isShowMode"
            hide-share
            hide-not-found-author
            @updateInvalid="updateAuthorsInvalid"
          />

          <NirCompensationAgreementCard
            class="mt-4"
            title="Основная информация"
            :is-show-mode="isShowMode"
            :selected-item.sync="nirCompensationAgreement"
            @updateInvalid="updateNirCompensationAgreementInvalid"
          />

          <CommentCard
            v-if="Boolean(nirCompensationAgreement.commonWork.comment)"
            class="mt-4"
            :comment="nirCompensationAgreement.commonWork.comment"
          />

          <CreatorCard :creator-name="nirCompensationAgreement.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { nirCompensationAgreementApi } from '@/api'
import TitleCard from '@/components/Works/elements/TitleCard'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import { dictionaryNames, workMode, workTypeName } from '@/scripts/consts'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { NirCompensationAgreement } from '@/models/works/NirCompensationAgreement'
import NirCompensationAgreementCard from '@/components/Works/NirCompensationCard/NirCompensationAgreementCard.vue'

export default {
  name: 'NirCompensationAgreementPage',

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.NirCompensationAgreement)
    }
  },

  components: {
    NirCompensationAgreementCard,
    CreatorCard,
    WorkTitleCard,
    CommentCard,
    AuthorsCard,
    TitleCard
  },

  mixins: [workListHeight],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.getData()
  },

  data: () => ({
    nirCompensationAgreement: new NirCompensationAgreement(),
    dataLoaded: false,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    nirCompensationAgreementInvalid: false,
    authorsInvalid: false,
    saveBtnLoading: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.nirCompensationAgreementInvalid || this.authorsInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode) await this.getDictionaries([dictionaryNames.Year])
      await this.getWorkTypes()
      await this.getNirCompensationAgreement()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getNirCompensationAgreement() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = this.$route.params?.id ? await nirCompensationAgreementApi.get(this.$route.params?.id) : null
          if (data) this.nirCompensationAgreement = new NirCompensationAgreement(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async saveNirCompensationAgreement(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.nirCompensationAgreement.id)
          this.nirCompensationAgreement.commonWork.workType = this.workTypeByName(workTypeName.NirCompensationAgreement)

        const body = this.nirCompensationAgreement.getForAPI()

        const data = this.nirCompensationAgreement.id
          ? await nirCompensationAgreementApi.update(body)
          : await nirCompensationAgreementApi.create(body)

        if (!this.nirCompensationAgreement.id)
          await this.$router.replace('/works/nirCompensationAgreement/edit/' + data.id)

        this.nirCompensationAgreement = new NirCompensationAgreement(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },

    updateNirCompensationAgreementInvalid(val) {
      this.nirCompensationAgreementInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.saveNirCompensationAgreement
    }
  }
}
</script>

<style scoped></style>
